<article class="popup-wrapper">
    <section class="picture">
        <img src="../../../../../../assets/images/finzy-flex-dashboard/nCash-popup.png" alt="nCash-popup-image" class="image">
    </section>
    <section class="nCash-wrapper">
        <div class="nCash-title">
            <span class="title-text">
                nCash
            </span>
        </div>
        <div class="nCash-description">
            <span class="description-text">
                <span>
                    nCash is a feature which provides you an option to withdraw a fixed or a customized amount periodically from your finzyFLEX investments. 
                </span>
                <br>
                <br>
                <span>
                    You have complete flexibility to set up your nCash preference as per your convenience:
                </span>
                <br>
                <span>a. You can chose the nCash amount</span>
                <br>
                <span>b. You can chose the nCash periodicity</span>
                <br>
                <span>c. You can chose the nCash date </span>
                <br>
                <br>
                <span>You can set your nCash preferences while registering with finzy or anytime post that from your dashboard.</span>
                <br>
                <br>
                <span>As a valued investor at finzy, you get access to the nCash feature without any charges or fees.</span>
                <br>
                <br>
                <span>Know more about how nCash works from <a class="hyperlink" href="faq?selectedTab=FINZY_FLEX&preferenceType=nCash" target="_blank">here</a></span>
            </span>
        </div>
        <div class="bottom">
            <button (click)="onClickClose()" class="primary-btn">BACK</button>
        </div>
    </section>
</article>